module.exports = __webpack_public_path__ + "static/media/circle_yellow.5df76ff1.png";